import {Grid} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React from 'react'

import {useAccordion} from './Accordion'
import {classes} from './Accordion.classes'

type TProps = React.PropsWithChildren<{classes?: React.CSSProperties}>

export const AccordionDetails: React.FC<TProps> = ({classes: classesProp, children}) => {
  const {expanded} = useAccordion()

  return (
    <Grid
      alignItems="flex-start"
      className={clsx(classes.details, expanded && classes.detailsExpanded, classesProp)}
      container
      direction="column"
      role="menu"
      wrap="nowrap"
    >
      {children}
    </Grid>
  )
}
